// 개인 근무시간 화면 문구 (관리자 팝업 = ko, 개인 QR 페이지 = ko/zh/vi/km 선택)
// zh(간체)·vi·km 번역은 현장 근로자 확인 후 필요하면 여기만 고치면 된다.
export const WORK_HOURS_LANGS = [
  { code: 'ko', label: '한국어' },
  { code: 'zh', label: '中文' },
  { code: 'vi', label: 'Tiếng Việt' },
  { code: 'km', label: 'ខ្មែរ' },
];

export const WORK_HOURS_TEXT = {
  ko: {
    title: '주간 근무시간',
    hours: '시간',
    total: '총 근무',
    base: '기본',
    EVENING: '야근',
    EARLY: '조근',
    WEEKEND: '특근',
    OVER: '12시간 초과',
    WARN: '주의 (10시간 이상)',
    OK: '정상',
    limit: '야근·조근 주 12시간',
    checked: '야근+조근',
    weekdays: ['월', '화', '수', '목', '금', '토', '일'],
    holiday: '공휴일',
    noRecord: '-',
    thisWeek: '이번 주',
    recent: '최근 3개월',
    loading: '불러오는 중...',
    invalid: '링크가 만료되었거나 올바르지 않습니다.\n관리자에게 문의하세요.',
    tooMany: '잠시 후 다시 시도하세요.',
    error: '불러오지 못했습니다. 잠시 후 다시 시도하세요.',
  },
  zh: {
    title: '每周工作时间',
    hours: '小时',
    total: '总工作时间',
    base: '正常工作',
    EVENING: '晚间加班',
    EARLY: '早晨加班',
    WEEKEND: '休息日加班',
    OVER: '超过12小时',
    WARN: '注意（10小时以上）',
    OK: '正常',
    limit: '晚间+早晨加班每周最多12小时',
    checked: '晚间+早晨加班',
    weekdays: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
    holiday: '节假日',
    noRecord: '-',
    thisWeek: '本周',
    recent: '最近3个月',
    loading: '加载中...',
    invalid: '链接无效或已过期。\n请联系管理员。',
    tooMany: '请稍后再试。',
    error: '加载失败，请稍后再试。',
  },
  vi: {
    title: 'Giờ làm việc trong tuần',
    hours: 'giờ',
    total: 'Tổng giờ làm',
    base: 'Cơ bản',
    EVENING: 'Tăng ca tối',
    EARLY: 'Tăng ca sáng',
    WEEKEND: 'Làm ngày nghỉ',
    OVER: 'Vượt 12 giờ',
    WARN: 'Chú ý (từ 10 giờ)',
    OK: 'Bình thường',
    limit: 'Tăng ca tối + sáng tối đa 12 giờ/tuần',
    checked: 'Tăng ca tối + sáng',
    weekdays: ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'],
    holiday: 'Ngày lễ',
    noRecord: '-',
    thisWeek: 'Tuần này',
    recent: '3 tháng gần đây',
    loading: 'Đang tải...',
    invalid: 'Liên kết không hợp lệ hoặc đã hết hạn.\nVui lòng liên hệ quản lý.',
    tooMany: 'Vui lòng thử lại sau.',
    error: 'Không tải được. Vui lòng thử lại sau.',
  },
  km: {
    title: 'ម៉ោងធ្វើការប្រចាំសប្តាហ៍',
    hours: 'ម៉ោង',
    total: 'ម៉ោងធ្វើការសរុប',
    base: 'ម៉ោងធម្មតា',
    EVENING: 'ថែមម៉ោងពេលល្ងាច',
    EARLY: 'ថែមម៉ោងពេលព្រឹក',
    WEEKEND: 'ធ្វើការថ្ងៃឈប់សម្រាក',
    OVER: 'លើស 12 ម៉ោង',
    WARN: 'ប្រុងប្រយ័ត្ន (ចាប់ពី 10 ម៉ោង)',
    OK: 'ធម្មតា',
    limit: 'ថែមម៉ោងល្ងាច + ព្រឹក អតិបរមា 12 ម៉ោង/សប្តាហ៍',
    checked: 'ថែមម៉ោងល្ងាច + ព្រឹក',
    weekdays: ['ច័ន្ទ', 'អង្គារ', 'ពុធ', 'ព្រហ', 'សុក្រ', 'សៅរ៍', 'អាទិត្យ'],
    holiday: 'ថ្ងៃបុណ្យ',
    noRecord: '-',
    thisWeek: 'សប្តាហ៍នេះ',
    recent: '3 ខែចុងក្រោយ',
    loading: 'កំពុងផ្ទុក...',
    invalid: 'តំណនេះមិនត្រឹមត្រូវ ឬផុតកំណត់។\nសូមទាក់ទងអ្នកគ្រប់គ្រង។',
    tooMany: 'សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ។',
    error: 'មិនអាចផ្ទុកបានទេ។ សូមព្យាយាមម្តងទៀត។',
  },
};
